<ng-template #tableTemplate>
    <n-data-table id="delete-extension-filtering-table"
        style="height: 3rem;"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>
